import React, { useState } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import './loacation-modal.scss';
import Drawer from '../../../../common/components/drawer_modal/drawer_modal';
import { LocationBodyForMPLS } from './location-body-mpls';
import { isNLD_OR_LL, isVPN_OR_DI, isVPN } from 'common/constants/app.constants';
import { IPAttributesSection } from './ip-attributes-section';
import { ServiceDetailsSection } from './service-details-section';
import { LocationBodyForDI } from './location-body-di';

const LocationBody = ({ rowData }) => {
  return (
    <div className="container_area">
      <div className="config_form">
        <div className="select_info">
          <div className="text">Location Details</div>
        </div>
        <div className="row">
          <div className="flg-lg-6 flg-md-6">
            <Input name="Company Name" type="text" value={rowData.companyName} label="Company Name" required disabled />
          </div>
          <div className="flg-lg-6 flg-md-6">
            <Input name="Selected Bandwidth" type="text" value={rowData.bandwidth ? rowData.bandwidth.toString() : 'N/A'} label="Selected Bandwidth" required disabled />
          </div>
        </div>
        <div className="row">
          <div className="flg-lg-6 flg-md-6">
            <Input name="Media Type" type="text" value={rowData.mediaType ? rowData.mediaType : 'N/A'} label="Media Type" required disabled />
          </div>
          <div className="flg-lg-6 flg-md-6">
            <Input name="Address" type="text" value={rowData.address ? rowData.address : 'N/A'} label="Address" required disabled />
          </div>
        </div>

        <ServiceDetailsSection rowData={rowData}></ServiceDetailsSection>
        <IPAttributesSection rowData={rowData}></IPAttributesSection>

        <div className="select_info">
          <div className="text">Pricing Details </div>
          <div className="tooltip_wrap">
            <span className="material-icons-outlined">info</span>
            <div className="tooltip">
              <div className="tooltip_content">Pricing Details</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="flg-lg-6 flg-md-6">
            <Input
              name="Annual Rental Price"
              type="text"
              value={`₹ ${rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.amount : 'N/A'}`}
              label="Annual Rental Price  "
              required
              disabled
            />
          </div>
          <div className="flg-lg-6 flg-md-6">
            <Input
              name="Installation Charge"
              type="text"
              value={`₹ ${rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.otc : 'N/A'}`}
              label="Installation Charge"
              required
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="flg-lg-6 flg-md-6">
            <Input
              name="Contract Period"
              type="text"
              value={`${rowData.rawContent.planDetail ? Math.floor(rowData.rawContent.planDetail.planPeriod / 12) : 'N/A'} years`}
              label="Contract Period"
              required
              disabled
            />
          </div>
          <div className="flg-lg-6 flg-md-6">
            <Input
              name="Total Price"
              type="text"
              value={`₹ ${
                Math.floor(rowData.rawContent.planDetail ? rowData.rawContent.planDetail.planPeriod / 12 : 0) *
                  (rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.amount : 0) +
                (rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.otc : 0)
              }`}
              label="Total Price"
              required
              disabled
            />
          </div>
        </div>
      </div>
      {rowData.rawContent && !rowData.rawContent.planDetail.standardIp && (
        <div className="notify_text">* Please note: Pricing for the non-standard IP attributes are under review and will be updated after DOA approval.</div>
      )}
    </div>
  );
};

const LocationModal = ({ showLocationModal, setShowLocationModal, rowData }) => {
  const getDrawerHeadingForLocation = (id, rawContent) => {
    const ipAttributes = rawContent.planDetail && rawContent.planDetail.standardIp ? 'Standard' : 'Non-Standard';
    return isNLD_OR_LL() ? `Link ID: ${id}` : `Location ID: ${id}  |  ${ipAttributes} IP Attributes*`;
  };
  let drawerContent = <LocationBody rowData={rowData}></LocationBody>;
  if (isVPN_OR_DI()) {
    drawerContent = isVPN() ? <LocationBodyForMPLS rowData={rowData}></LocationBodyForMPLS> : <LocationBodyForDI rowData={rowData}></LocationBodyForDI>;
  }
  return (
    <Drawer
      showOnlyClose={true}
      isOpen={showLocationModal}
      setIsOpen={setShowLocationModal}
      headingTitle={getDrawerHeadingForLocation(rowData.locationId || rowData.lineItemId, rowData.rawContent)}
      drawerContent={drawerContent}
    />
  );
};
export default LocationModal;
